<ngx-loading [show]="loading"></ngx-loading>
<div class="container-fluid p-0 financial-report-container" class="p-4" *ngIf="financialReport" ngbAutoFocus>
  <ng-container *ngIf="isCustomer() && financialReport.status == statuses.draft">
    <div class="d-flex">
      <span><b>Contract Number: </b></span><span class="ml-2">{{ purchaseOrder.customer_po_number }}</span>
    </div>
    <div class="d-flex">
      <span><b>Vendor: </b></span><span class="ml-2">{{ supplier?.name }}</span>
    </div>
    <div class="d-flex row">
      <mat-form-field class="col-4" [ngClass]="{ 'required-border': !financialReport.financialReportTypeId }">
        <input matInput [(ngModel)]="financialReport.financialReportType"
          placeholder="Frequency of Voucher Submission *" [matAutocomplete]="autoTypes"
          #autoTrigger="matAutocompleteTrigger" (input)="filterTypes($event.target.value)" />
        <mat-autocomplete #autoTypes="matAutocomplete" [displayWith]="displayWithType"
          (optionSelected)="selectType($event)" class="financial-report-panel">
          <div class="mat-option">
            <a class="d-block" (click)="addNewType(); autoTrigger.closePanel();">
              Add new type
            </a>
          </div>
          <mat-option *ngFor="let type of filteredTypes" [value]="type">
            {{type.name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="d-flex row">
      <mat-form-field class="col-4" [ngClass]="{ 'required-border': !financialReport.taxPayerId }">
        <input [(ngModel)]="financialReport.taxPayerId" class="col-3 p-0" matInput
          placeholder="Taxpayer Identification No *" />
      </mat-form-field>
    </div>
  </ng-container>
  <ng-container *ngIf="!isCustomer() || isCustomer() && financialReport.status != statuses.draft">
    <div class="d-flex print-row">
      <span><b>Contract Number: </b></span> <span class="ml-2">{{ purchaseOrder.customer_po_number }}</span>
    </div>
    <div class="d-flex print-row">
      <span><b>Vendor: </b></span> <span class="ml-2">{{ supplier?.name }}</span>
    </div>
    <div class="d-flex print-row">
      <span><b>Frequency of Voucher Submission: </b></span>
      <span class="ml-2">{{ financialReport.financialReportType.name }}</span>
    </div>
    <div class="d-flex print-row">
      <span><b>Taxpayer Identification No: </b></span> <span class="ml-2">{{ financialReport.taxPayerId }}</span>
    </div>
  </ng-container>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="divue">&times;</span>
  </button>
  <div class="d-flex flex-column mt-2 ml-3 table-container" *ngIf="financialReport">
    <div class="table">
      <div class="d-flex header">
        <div class="title-col"></div>
        <div class="input-col">Contractual Amounts</div>
        <mat-radio-group [(ngModel)]="financialReport.currentColumn" class="d-flex" color="primary">
          <div *ngFor="let column of financialReport.financialReportType.financialReportColumns"
            class="input-col d-flex align-items-center flex-column">
            <mat-radio-button class="example-radio-button" [value]="column.order" [disabled]="!isCustomer()">
            </mat-radio-button>
            <div>{{column.name}}</div>
          </div>
        </mat-radio-group>
        <div class="input-col">Comulative Exp.</div>
        <div class="input-col">Balance Remaining</div>
      </div>
      <div>
        <div>
          <div class="col-12"><b>SECTION A - Contract Deliverables (Numbers To Be Served); Service Unit</b></div>
        </div>
        <ng-container
          *ngFor="let financialReportUnit of filterFinancialReportUnits(financialReport.financialReportUnits, true); let i = index"
          class="row w-100">
          <div class="d-flex" [ngClass]="{'bg-danger': financialReportUnit.balanceRemaining < 0}">
            <div class="title-col">
              <button class="expanded-batton"
                *ngIf="financialReportUnit.childs && financialReportUnit.childs.length > 0" mat-icon-button
                (click)="financialReportUnit.expanded = !financialReportUnit.expanded">
                <mat-icon>{{ !financialReportUnit.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
              <button *ngIf="!financialReportUnit.isAdded && isCustomer()"
                [disabled]="isUnitExist(financialReportUnit) || !isCanAddUnit(financialReportUnit)" mat-fab
                color="primary" class="add-unit-button align-self-center"
                (click)="addUnit(financialReportUnit); recalculate(financialReportUnit)">
                <mat-icon>add</mat-icon>
              </button>
              <div *ngIf="!financialReportUnit.isAdded && isCustomer()" class="d-flex justify-content-end w-100">
                <mat-form-field [ngClass]="{ 'required-border': !financialReportUnit.comment }" class="comment-field">
                  <input matInput [(ngModel)]="financialReportUnit.comment" placeholder="Comment"
                    [matAutocomplete]="autoComment" />
                  <mat-autocomplete #autoComment="matAutocomplete" class="financial-report-panel">
                    <mat-option *ngFor="let comment of comments" [value]="comment">
                      {{comment}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field [ngClass]="{ 'required-border': !financialReportUnit.name }" class="unit-name-field">
                  <input matInput placeholder="New unit" [matAutocomplete]="autoUnit"
                    [(ngModel)]="financialReportUnit.name" (change)="onChangeUnitName(financialReportUnit)"
                    (input)="filterUnits($event.target.value)" />
                  <mat-autocomplete #autoUnit="matAutocomplete" class="financial-report-panel">
                    <mat-option *ngFor="let unit of filteredUnits" [value]="unit.name">
                      {{unit.name}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div *ngIf="financialReportUnit.isAdded" class="d-flex align-items-center justify-content-start w-100">
                <span class="text-danger font-weight-bold">Unit {{ i + 1 }}:
                  <span class="ml-2">{{financialReportUnit.comment}}</span>
                  <span class="ml-2"> {{ financialReportUnit.name }}</span>
                </span>
              </div>
            </div>
            <div class="p-0 input-col">
              <mat-form-field class="input-col">
                <input matInput type="number" step="0.01"
                  [disabled]="!isCustomer() || isSomeActiveChilds(financialReportUnit) || financialReport.totalMaxPrice"
                  [(ngModel)]="financialReportUnit.contractualAmount" (change)="recalculate(financialReportUnit)" />
              </mat-form-field>
            </div>
            <div class="p-0 input-col" *ngFor="let column  of orderColumns(financialReportUnit.columns)">
              <mat-form-field class="input-col">
                <input type="number" step="0.01" matInput
                  [disabled]="checkStatus(statuses.closed) || !isCurrentColumnOrder(column)  || isSomeActiveChilds(financialReportUnit)"
                  [(ngModel)]="column.value" (change)="recalculate(financialReportUnit, column)" />
              </mat-form-field>
            </div>
            <div class="input-col">
              <span class="total-span">{{(financialReportUnit.comulativeExp ? financialReportUnit.comulativeExp : 0) |
                number:'1.2-2'}}</span>
            </div>
            <div class="input-col">
              <span class="total-span">{{(financialReportUnit.balanceRemaining ? financialReportUnit.balanceRemaining :
                0) | number:'1.2-2'}}</span>
            </div>
            <div *ngIf="financialReportUnit.isAdded && isCustomer() && checkStatus(statuses.draft)"
              class="position-absolute trash-icon">
              <mat-icon
                (click)="removeUnitFromArray(financialReportUnit, financialReport.financialReportUnits)">delete</mat-icon>
            </div>
          </div>
          <ng-container *ngIf="financialReportUnit.expanded">
            <ng-container *ngFor="let child of financialReportUnit.childs">
              <ng-container
                *ngTemplateOutlet="subUnit; context: { unit: child, parent: financialReportUnit, level: 1, firstLevelUnit: financialReportUnit  }"></ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <div>
          <div class="col-12"><span class="m-3"></span></div>
        </div>
        <div>
          <div class="col-12">
            <b>SECTION B - Amounts Claimed
              <span class="text-danger font-weight-bold">
                Total Unit Price
              </span></b>
          </div>
        </div>
        <ng-container
          *ngFor="let financialReportUnit of filterFinancialReportUnits(financialReport.financialReportUnits); let i = index"
          class="row w-100">
          <div class="d-flex" [ngClass]="{'bg-danger': financialReportUnit.balanceRemaining < 0}">
            <div class="title-col">
              <button class="expanded-batton"
                *ngIf="financialReportUnit.childs && financialReportUnit.childs.length > 0" mat-icon-button
                (click)="financialReportUnit.expanded = !financialReportUnit.expanded">
                <mat-icon>{{ !financialReportUnit.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
              <div class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center justify-content-start">
                  <span class="text-danger font-weight-bold">
                    Unit {{ i + 1 }}:
                    <span class="ml-2">{{financialReportUnit.comment}}</span>
                    <span class="ml-2"> {{ financialReportUnit.name }} </span>
                  </span>
                </div>
                <mat-form-field class="ml-2 input-col price-col" *ngIf="!isSomeActiveChilds(financialReportUnit)">
                  <input [disabled]="!isCustomer() " matInput type="number" step="0.01"
                    [(ngModel)]="financialReportUnit.pricePerUnit" (change)="recalculate(financialReportUnit)" />
                </mat-form-field>
              </div>
            </div>
            <div class="p-0 input-col">
              <span class="total-span">
                {{(financialReportUnit.totalContractualAmount ? financialReportUnit.totalContractualAmount : 0) |
                currency}}
              </span>
            </div>
            <div class="p-0 input-col" *ngFor="let column  of orderColumns(financialReportUnit.columns)">
              <span class="total-span">
                {{(column.totalValue ? column.totalValue : 0) | currency }}
              </span>
            </div>
            <div class="input-col">
              <span class="total-span">
                {{(financialReportUnit.totalComulativeExp ? financialReportUnit.totalComulativeExp : 0) |
                currency}}</span>
            </div>
            <div class="input-col" [ngClass]="{'bg-danger': isTotalMaxPrriceLessThanBalanceRemaining()}">
              <span class="total-span">
                {{(financialReportUnit.totalBalanceRemaining ? financialReportUnit.totalBalanceRemaining : 0) |
                currency}}</span>
            </div>
          </div>
          <ng-container *ngIf="financialReportUnit.expanded">
            <ng-container *ngFor="let child of filterFinancialReportUnits(financialReportUnit.childs)">
              <ng-container
                *ngTemplateOutlet="subTotalUnit; context: { unit: child, parent: financialReportUnit, level: 1, firstLevelUnit: financialReportUnit  }"></ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <div class="d-flex font-weight-bold text-danger">
          <div class="title-col total-span">TOTAL CONTRACT AMOUNT</div>
          <div class="p-0 input-col">
            <mat-form-field class="input-col" *ngIf="!isAnyUnitAmmountAdded()">
              <input matInput type="number" step="0.01" [disabled]="!isCustomer()"
                [(ngModel)]="financialReport.totalMaxPrice" />
            </mat-form-field>
            <span class="total-span" *ngIf="isAnyUnitAmmountAdded()">{{ (calculateTotal('contractualAmount') ?
              calculateTotal('contractualAmount') : 0) | currency}}</span>
          </div>
          <div class="p-0 input-col" *ngFor="let column of financialReport.financialReportType.financialReportColumns">
            <span class="total-span">{{ (calculateTotalColumn(column) ? calculateTotalColumn(column) : 0) |
              currency}}</span>
          </div>
          <div class="p-0 input-col">
            <span class="total-span">{{ (calculateTotal('comulativeExp') ? calculateTotal('comulativeExp') : 0) |
              currency}}</span>
          </div>
          <div class="p-0 input-col" [ngClass]="{'bg-danger': isTotalMaxPrriceLessThanBalanceRemaining()}">
            <span class="total-span">{{ (calculateTotal('balanceRemaining') ? calculateTotal('balanceRemaining') : 0) |
              currency}}</span>
          </div>
        </div>
        <div>
          <div class="col-12"><span class="m-3"></span></div>
        </div>
        <div>
          <div class="col-12" class="text-center"><b>CERTIFICATE</b></div>
        </div>
        <div>
          <div class="col-12">
            <span>
              The undersigned certifies that: the expenditures as shown above have been made for the Project identified
              above and supporting rolls or absthacts, vouchers and other documents which are deemed a part of hereto
              are just, thue and correct and have been duly authorized; that all service units have been delivered in
              the numbers indicated herein; and that all expenditures have been made in accordance with the approved
              project proposal. Records are attached and also available in the files to support these costs.
            </span>
          </div>
        </div>
        <!-- <div class="d-flex">
          <div class="col-4"><span> Signature/Project Director </span></div>
          <div class="col-2"><span>Date </span></div>
          <div class="col-2">
            <span>Office Use Only </span><br />
            <span>DSSLM 2021-#####</span>
          </div>

          <div class="col-4">
            <div class="col-4"><span> Title </span></div>
            <div class="col-2"><span> Agency </span></div>
          </div>
        </div> -->
        <div>
          <div class="col-12"><span class="m-3"></span></div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-column w-100">
    <div>
      <div class="col-12" class="text-center"><b>SIGNERS</b></div>
    </div>
    <div class="row w-100">
      <div class="col-3">
        <span class="ml-3"> <b>Field</b></span>
      </div>
      <div class="col-3">
        <span class="ml-3"> <b>Email</b></span>
      </div>
      <div class="col-2">
        <span class="ml-2"> <b>First Name</b></span>
      </div>
      <div class="col-2">
        <span class="ml-2"> <b>Last Name</b></span>
      </div>
      <!-- <div class="col-2">
        <span class="ml-2"> <b>Sign Order</b></span>
      </div> -->
      <div class="col-2">
        <span class="ml-2"> <b>Title</b></span>
      </div>
    </div>
    <ng-container *ngFor="let financialReportSigner of getFinancialReportSigners(); let i = index" class="row w-100">
      <ng-container *ngIf="!financialReportSigner.isAdded">
        <div class="row w-100 align-items-center d-flex signers-table mt-2">
          <!-- <button
            [disabled]="isSignerExist(financialReportSigner.signer)"
            mat-fab
            color="primary"
            class="add-unit-button align-self-center"
            (click)="addSigner(financialReportSigner)"
          >
            <mat-icon>add</mat-icon>
          </button> -->
          <div class="col-3">
            <span class="ml-3">{{getSignatureFieldTitle(financialReportSigner)}}</span>
          </div>
          <div class="col-3">
            <mat-form-field>
              <input matInput [(ngModel)]="financialReportSigner.signer.email" placeholder="Email"
                [matAutocomplete]="autoSigner" (input)="filterSigners($event.target.value, financialReportSigner)" />
              <mat-autocomplete class="financial-report-panel" #autoSigner="matAutocomplete"
                (optionSelected)="selectSigner($event, financialReportSigner)">
                <mat-option *ngFor="let signer of filteredSigners('', financialReportSigner)" [value]="signer.email">
                  {{signer.firstName}} {{signer.lastName}} ({{signer.email}})
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field>
              <input matInput [(ngModel)]="financialReportSigner.signer.firstName" placeholder="First Name" />
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field>
              <input matInput [(ngModel)]="financialReportSigner.signer.lastName" placeholder="Last Name" />
            </mat-form-field>
          </div>
          <!-- <div class="col-2">
            <mat-form-field>
              <input
                type="number"
                matInput
                [(ngModel)]="financialReportSigner.signer.signingOrder"
                placeholder="Signing Order"
              />
            </mat-form-field>
          </div> -->
          <div class="col-2">
            <mat-form-field>
              <input matInput placeholder="Role" #inputRef
                (input)="onInputChange(inputRef, financialReportSigner.signer)" />
              <span matSuffix>
                <mat-icon matTooltip="Value cannot have any spaces or unique symbols">info</mat-icon>
              </span>
            </mat-form-field>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="financialReportSigner.isAdded">
        <div class="row w-100 signers-table">
          <div class="signer-trash-button align-self-center" *ngIf="companyType == financialReportSigner.companyType">
            <mat-icon (click)="removeSigner(financialReportSigner)">delete</mat-icon>
          </div>
          <div class="col-3">
            <span class="ml-3">{{getSignatureFieldTitle(financialReportSigner)}}</span>
          </div>
          <div class="col-3">
            <span class="ml-3"> {{ financialReportSigner.signer.email }}</span>
          </div>
          <div class="col-2">
            <span class="ml-2"> {{ financialReportSigner.signer.firstName }}</span>
          </div>
          <div class="col-2">
            <span class="ml-2"> {{ financialReportSigner.signer.lastName }}</span>
          </div>
          <!-- <div class="col-2">
            <span class="ml-2"> {{ financialReportSigner.signer.signingOrder }}</span>
          </div> -->
          <div class="col-2">
            <span class="ml-2"> {{ financialReportSigner.signer.role }}</span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="modal-footer mt-4">
    <button class="pull-right ml-2" mat-raised-button (click)="closeModal()">
      Cancel
    </button>
    <button *ngIf="isCustomer()" class="pull-right ml-2" mat-raised-button (click)="onSendVoucherClick()"
      [disabled]="financialReport.financialReportSigners.length == 0"
      [matTooltip]="financialReport.financialReportSigners.length == 0 ? 'The supplier has not yet added the signer to the report' : ''">
      Generate Voucher {{getVoucherColumnName()}}
    </button>
    <button class="pull-right ml-2" mat-raised-button (click)="generatePDF()">
      PDF
    </button>
    <button *ngIf="isCustomer() && checkStatus(statuses.draft) || !isCustomer() && checkStatus(statuses.submitted)"
      class="pull-right ml-2" mat-raised-button color="primary"
      [disabled]="isBalanceRemainingNegative() || !isFinancialReportValid()" (click)="onSaveClick()">
      Save Draft
    </button>
    <button *ngIf="isCustomer()"
      class="pull-right ml-2" mat-raised-button color="primary" (click)="savePDFToSectionC()">
      Save amended FR to section c
    </button>
    <button *ngIf="isCustomer() && checkStatus(statuses.submitted)" class="pull-right ml-2" mat-raised-button
      color="primary" [disabled]="isBalanceRemainingNegative() || !isFinancialReportValid()" (click)="onSaveClick()">
      Save
    </button>
    <button *ngIf="isCustomer() && checkStatus(statuses.draft) || !isCustomer() && checkStatus(statuses.submitted)"
      class="pull-right ml-2" mat-raised-button color="primary"
      [disabled]="isBalanceRemainingNegative() || !isCustomer() && financialReport.financialReportSigners?.length == 0 || isTotalMaxPrriceLessThanBalanceRemaining()"
      (click)="onSubmitClick()">
      Submit
    </button>
  </div>
</div>

<ng-template #subUnit let-unit="unit" let-parent="parent" let-level="level" let-firstLevelUnit="firstLevelUnit">
  <div class="d-flex" [ngClass]="{'bg-danger': unit.balanceRemaining < 0}">
    <div class="title-col">
      <button class="expanded-batton" *ngIf="unit.childs && unit.childs.length > 0 && level < 2" mat-icon-button
        (click)="unit.expanded = !unit.expanded">
        <mat-icon>{{ !unit.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <button *ngIf="!unit.isAdded && isCustomer()" [disabled]="isUnitExist(unit) || !isCanAddUnit(unit)" mat-fab
        color="primary" class="add-unit-button align-self-center"
        (click)="addSubUnit(unit, parent, level); recalculate(firstLevelUnit)">
        <mat-icon>add</mat-icon>
      </button>
      <div *ngIf="!unit.isAdded && isCustomer()" class="d-flex justify-content-end w-100">
        <span class="text-danger font-weight-bold">
          {{getPointer('- ', level)}}
        </span>
        <mat-form-field [ngClass]="{ 'required-border': !unit.comment }" class="comment-field">
          <input matInput [(ngModel)]="unit.comment" placeholder="Comment" [matAutocomplete]="autoComment" />
          <mat-autocomplete #autoComment="matAutocomplete" class="financial-report-panel">
            <mat-option *ngFor="let comment of comments" [value]="comment">
              {{comment}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field [ngClass]="{ 'required-border': !unit.name }" class="unit-name-field">
          <input matInput [(ngModel)]="unit.name" placeholder="Level {{level + 1}} unit"
            (change)="onChangeUnitName(unit)" />
        </mat-form-field>
      </div>
      <div *ngIf="unit.isAdded" class="d-flex align-items-center justify-content-start w-100">
        <mat-checkbox class="mr-2" [(ngModel)]="unit.isCalculating" (change)="recalculate(firstLevelUnit)"
          [disabled]="!isCustomer()"></mat-checkbox>
        <span class="text-danger font-weight-bold">{{getPointer('- ', level)}}</span>
        <span class="ml-2">{{unit.comment}}</span>
        <span class="ml-2">{{unit.name}}</span>
      </div>
    </div>
    <div class="p-0 input-col">
      <mat-form-field class="input-col">
        <input matInput type="number" step="0.01" [disabled]="!isCustomer()  || financialReport.totalMaxPrice"
          [(ngModel)]="unit.contractualAmount" (change)="recalculate(firstLevelUnit)" />
      </mat-form-field>
    </div>
    <div class="p-0 input-col" *ngFor="let column  of orderColumns(unit.columns)">
      <mat-form-field class="input-col">
        <input matInput type="number" step="0.01"
          [disabled]="checkStatus(statuses.closed) || !isCurrentColumnOrder(column)" [(ngModel)]="column.value"
          (change)="recalculate(firstLevelUnit, column)" />
      </mat-form-field>
    </div>
    <div class="input-col">
      <span class="total-span">{{(unit.comulativeExp ? unit.comulativeExp : 0) | number:'1.2-2' }}</span>
    </div>
    <div class="input-col" [ngClass]="{'bg-danger': isTotalMaxPrriceLessThanBalanceRemaining()}">
      <span class="total-span">{{(unit.balanceRemaining ? unit.balanceRemaining : 0) | number:'1.2-2' }}</span>
    </div>
    <div *ngIf="unit.isAdded && isCustomer() && checkStatus(statuses.draft)" class="position-absolute trash-icon">
      <mat-icon (click)="removeUnitFromArray(unit, parent.childs)">delete</mat-icon>
    </div>
  </div>
  <ng-container *ngIf="unit.expanded">
    <ng-container *ngFor="let child of filterFinancialReportUnits(unit.childs, true)">
      <ng-container
        *ngTemplateOutlet="subUnit; context: { unit: child, parent: unit, level: level+1, firstLevelUnit: firstLevelUnit }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #subTotalUnit let-unit="unit" let-level="level" let-firstLevelUnit="firstLevelUnit">
  <div class="d-flex" [ngClass]="{'bg-danger': unit.balanceRemaining < 0}">
    <div class="title-col">
      <button class="expanded-batton" *ngIf="unit.childs && unit.childs.length > 0 && level < 2" mat-icon-button
        (click)="unit.expanded = !unit.expanded">
        <mat-icon>{{ !unit.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <div class="d-flex align-items-center justify-content-between w-100">
        <div class="d-flex align-items-center justify-content-start">
          <span class="text-danger font-weight-bold">
            {{getPointer('- ', level)}}
          </span>
          <span class="ml-2">{{unit.comment}}</span>
          <span class="ml-2"> {{ unit.name }}: </span>
        </div>
        <mat-form-field class="input-col price-col">
          <input [disabled]="!isCustomer()" matInput type="number" step="0.01" [(ngModel)]="unit.pricePerUnit"
            (change)="recalculate(firstLevelUnit)" />
        </mat-form-field>
      </div>
    </div>
    <div class="p-0 input-col">
      <span class="total-span"> {{(unit.totalContractualAmount ? unit.totalContractualAmount : 0) | currency}}</span>
    </div>
    <div class="p-0 input-col" *ngFor="let column  of orderColumns(unit.columns)">
      <span class="total-span"> {{(column.totalValue ? column.totalValue : 0) | currency}}</span>
    </div>
    <div class="input-col">
      <span class="total-span"> {{(unit.totalComulativeExp ? unit.totalComulativeExp : 0) | currency}}</span>
    </div>
    <div class="input-col" [ngClass]="{'bg-danger': isTotalMaxPrriceLessThanBalanceRemaining()}">
      <span class="total-span"> {{(unit.totalBalanceRemaining ? unit.totalBalanceRemaining : 0) | currency}}</span>
    </div>
  </div>
  <ng-container *ngIf="unit.expanded">
    <ng-container *ngFor="let child of filterFinancialReportUnits(unit.childs)">
      <ng-container
        *ngTemplateOutlet="subTotalUnit; context: { unit: child, parent: unit, level: level+1, firstLevelUnit: firstLevelUnit  }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<!-- PRINT BLOCK -->
<div [ngClass]="{'h-0 invisible': !isGenerating}" #printFinancialReport *ngIf="financialReport"
  style="width: fit-content;">
  <div class="table-container container-fluid">
    <div class="d-flex print-row">
      <span><b>Contract Number: </b></span> <span class="ml-2">{{ purchaseOrder.customer_po_number }}</span>
    </div>
    <div class="d-flex print-row">
      <span><b>Vendor: </b></span> <span class="ml-2">{{ supplier?.name }}</span>
    </div>
    <div class="d-flex print-row">
      <span><b>Frequency of Voucher Submission: </b></span>
      <span class="ml-2">{{ financialReport.financialReportType.name }}</span>
    </div>
    <div class="d-flex print-row">
      <span><b>Taxpayer Identification No: </b></span> <span class="ml-2">{{ financialReport.taxPayerId }}</span>
    </div>
    <div class="d-flex flex-column" style="width: fit-content;" *ngIf="financialReport">
      <div class="table m-0">
        <div class="d-flex header print-row">
          <div class="title-col"></div>
          <div class="input-col">Contractual Amounts</div>
          <div *ngFor="let column of financialReport.financialReportType.financialReportColumns" class="input-col">
            {{ column.name }}
          </div>
          <div class="input-col">Comulative Exp.</div>
          <div class="input-col">Balance Remaining</div>
        </div>
        <div class="col-12 print-row">
          <b>SECTION A - Contract Deliverables (Numbers To Be Served); Service Unit</b>
        </div>
        <ng-container
          *ngFor="let financialReportUnit of filterFinancialReportUnits(financialReport.financialReportUnits); let i = index"
          class="w-100">
          <div class="d-flex print-row">
            <div class="title-col">
              <div *ngIf="financialReportUnit.isAdded" class="d-flex align-items-center justify-content-start w-100">
                <span class="text-danger font-weight-bold">Unit {{ i + 1 }}:
                  <span class="ml-2"> {{ financialReportUnit.comment }} </span>
                  <span class="ml-2"> {{ financialReportUnit.name }} </span>
                </span>
              </div>
            </div>
            <div class="p-0 input-col for-print">
              <span>{{financialReportUnit.contractualAmount | number:'1.2-2'}}</span>
            </div>
            <div class="p-0 input-col for-print" *ngFor="let column of orderColumns(financialReportUnit.columns)">
              <span>{{column.value | number:'1.2-2'}}</span>
            </div>
            <div class="input-col for-print">
              <span>{{ (financialReportUnit.comulativeExp ? financialReportUnit.comulativeExp : 0) |
                number:'1.2-2'}}</span>
            </div>
            <div class="input-col for-print">
              <span>{{ (financialReportUnit.balanceRemaining ? financialReportUnit.balanceRemaining : 0) |
                number:'1.2-2' }}</span>
            </div>
          </div>
          <ng-container>
            <ng-container *ngFor="let child of filterFinancialReportUnits(financialReportUnit.childs)">
              <ng-container
                *ngTemplateOutlet="subPrintUnit; context: { unit: child, parent: financialReportUnit, level: 1 }"></ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <div class="col-12 print-row" style="height: 30px;"></div>
        <div class="col-12 print-row">
          <b>SECTION B - Amounts Claimed
            <span class="text-danger font-weight-bold">
              Total Unit Price
            </span></b>
        </div>
        <ng-container
          *ngFor="let financialReportUnit of filterFinancialReportUnits(financialReport.financialReportUnits); let i = index"
          class="w-100">
          <div class="d-flex print-row">
            <div class="title-col">
              <div class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center justify-content-start">
                  <span class="text-danger font-weight-bold">
                    Unit {{ i + 1 }}:
                    <span class="ml-2"> {{ financialReportUnit.comment }} </span>
                    <span class="ml-2"> {{ financialReportUnit.name }} </span>
                  </span>
                </div>
                <div class="ml-2 input-col for-print price-col" *ngIf="!isSomeActiveChilds(financialReportUnit)">
                  <span>{{(financialReportUnit.pricePerUnit ? financialReportUnit.pricePerUnit : 0) | currency}}</span>
                </div>
              </div>
            </div>
            <div class="p-0 input-col for-print">
              <span>{{(financialReportUnit.totalContractualAmount ? financialReportUnit.totalContractualAmount : 0) |
                currency}}</span>
            </div>
            <div class="p-0 input-col for-print" *ngFor="let column of orderColumns(financialReportUnit.columns)">
              <span>{{(column.totalValue ? column.totalValue : 0) | currency}}</span>
            </div>
            <div class="input-col for-print">
              <span>
                {{ (financialReportUnit.totalComulativeExp ? financialReportUnit.totalComulativeExp : 0) |
                currency}}</span>
            </div>
            <div class="input-col for-print">
              <span>
                {{ (financialReportUnit.totalBalanceRemaining ? financialReportUnit.totalBalanceRemaining : 0) |
                currency}}</span>
            </div>
          </div>
          <ng-container>
            <ng-container *ngFor="let child of filterFinancialReportUnits(financialReportUnit.childs)">
              <ng-container
                *ngTemplateOutlet="subPrintTotalUnit; context: { unit: child, parent: financialReportUnit, level: 1 }"></ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <div class="d-flex print-row text-danger font-weight-bold">
          <div class="title-col">TOTAL CONTRACT AMOUNT</div>
          <div class="p-0 input-col for-print">
            <span *ngIf="isAnyUnitAmmountAdded()">{{ (calculateTotal('contractualAmount') ?
              calculateTotal('contractualAmount') : 0) | currency}}</span>
            <span *ngIf="!isAnyUnitAmmountAdded()">{{ financialReport.totalMaxPrice | currency}}</span>
          </div>
          <div class="p-0 input-col for-print"
            *ngFor="let column of financialReport.financialReportType.financialReportColumns">
            <span>{{ (calculateTotalColumn(column) ? calculateTotalColumn(column) : 0) | currency}}</span>
          </div>
          <div class="p-0 input-col for-print">
            <span>{{ (calculateTotal('comulativeExp') ? calculateTotal('comulativeExp') : 0) | currency}}</span>
          </div>
          <div class="p-0 input-col for-print">
            <span>{{ (calculateTotal('balanceRemaining') ? calculateTotal('balanceRemaining') : 0) | currency}}</span>
          </div>
        </div>
        <div class="col-12 print-row" style="height: 30px;"></div>
        <div class="col-12 print-row" class="text-center"><b>CERTIFICATE</b></div>
        <div class="col-12 print-row">
          <span>
            The undersigned certifies that: the expenditures as shown above have been made for the Project identified
            above and supporting rolls or absthacts, vouchers and other documents which are deemed a part of hereto are
            just, thue and correct and have been duly authorized; that all service units have been delivered in the
            numbers indicated herein; and that all expenditures have been made in accordance with the approved project
            proposal. Records are attached and also available in the files to support these costs.
          </span>
        </div>
        <!-- <div class="d-flex print-row">
          <div class="col-4">
            <span> Signature/Project Director </span></div>
          <div class="col-2"><span>Date </span></div>
          <div class="col-2">
            <span>Office Use Only </span><br />
            <span>DSSLM 2021-#####</span>
          </div>

          <div class="col-4">
            <div class="col-4"><span> Title </span></div>
            <div class="col-2"><span> Agency </span></div>
          </div>
        </div> -->
        <div class="col-12 print-row" style="height: 260px;"></div>
      </div>
    </div>
  </div>

  <ng-template #subPrintUnit let-unit="unit" let-parent="parent" let-level="level">
    <div class="d-flex print-row">
      <div class="title-col">
        <div *ngIf="unit.isAdded" class="d-flex align-items-center justify-content-start w-100">
          <span class="text-danger font-weight-bold">{{ getPointer('- ', level) }}</span>
          <span class="ml-2"> {{ unit.comment }} </span>
          <span class="ml-2"> {{ unit.name }}: </span>
        </div>
      </div>
      <div class="p-0 input-col for-print">
        <span>{{(unit.contractualAmount? unit.contractualAmount : 0) | number:'1.2-2' }}</span>
      </div>
      <div class="p-0 input-col for-print" *ngFor="let column of orderColumns(unit.columns)">
        <span>{{(column.value ? column.value : 0) | number:'1.2-2' }}</span>
      </div>
      <div class="input-col for-print">
        <span>{{ (unit.comulativeExp ? unit.comulativeExp : 0) | number:'1.2-2' }}</span>
      </div>
      <div class="input-col for-print">
        <span>{{ (unit.balanceRemaining ? unit.balanceRemaining : 0) | number:'1.2-2' }}</span>
      </div>
    </div>
    <ng-container>
      <ng-container *ngFor="let child of filterFinancialReportUnits(unit.childs)">
        <ng-container
          *ngTemplateOutlet="subPrintUnit; context: { unit: child, parent: unit, level: level + 1 }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #subPrintTotalUnit let-unit="unit" let-level="level">
    <div class="d-flex print-row">
      <div class="title-col">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center justify-content-start">
            <span class="text-danger font-weight-bold"> {{ getPointer('- ', level) }} </span>
            <span class="ml-2"> {{ unit.comment }} </span>
            <span class="ml-2"> {{ unit.name }}: </span>
          </div>
          <div class="ml-2 input-col for-print price-col">
            <span>{{(unit.pricePerUnit ? unit.pricePerUnit : 0) | currency}}</span>
          </div>
        </div>
      </div>
      <div class="p-0 input-col for-print">
        <span>{{(unit.totalContractualAmount ? unit.totalContractualAmount : 0) | currency}}</span>
      </div>
      <div class="p-0 input-col for-print" *ngFor="let column of orderColumns(unit.columns)">
        <span>{{(column.totalValue ? column.totalValue : 0) | currency}}</span>
      </div>
      <div class="input-col for-print">
        <span> {{ (unit.totalComulativeExp ? unit.totalComulativeExp : 0) | currency}}</span>
      </div>
      <div class="input-col for-print">
        <span> {{ (unit.totalBalanceRemaining ? unit.totalBalanceRemaining : 0) | currency}}</span>
      </div>
    </div>
    <ng-container>
      <ng-container *ngFor="let child of filterFinancialReportUnits(unit.childs)">
        <ng-container
          *ngTemplateOutlet="subPrintTotalUnit; context: { unit: child, parent: unit, level: level + 1 }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-template>
</div>